import { Reducer } from "redux";
import { Action, ActionType } from "../../actions";
import { RegionEditorData } from "../../state/Regions/EditorData";


const updateRegionsEditorData: Reducer<RegionEditorData> = (state: RegionEditorData = new RegionEditorData(), action: Action<ActionType, RegionEditorData>) => {
  switch (action.type) {
    case ActionType.REGIONS_EDITOR_DATA_RESET:
      return new RegionEditorData();
    case ActionType.REGIONS_EDITOR_DATA_FETCHED:
      return { ...state, regionData: action.data };
    case ActionType.REGIONS_EDITOR_DATA_COPIED:
      return { ...state, regionData: { ...action.data} };
    case ActionType.REGIONS_EDITOR_DATA_UPDATED:
      return { ...state, regionData: { ...state.regionData, ...action.data } };
    case ActionType.REGIONS_EDITOR_DATA_SAVED:
      return { ...state, readyToSave: false };
    case ActionType.REGIONS_EDITOR_DATA_VALIDATED:
      return { ...state, validation: action.data };
    default:
      return state;
  }
};

export default updateRegionsEditorData;